export default "__VITE_ASSET__HaEXjw8h__"